export default {
  ["agent_admin"]: ``,
  ["edit_pwd"]: ``,
  ["logout"]: ``,
  ["login"]: ``,
  ["register"]: ``,
  ["dashboard"]: ``,
  ["registration"]: ``,
  ["incomes"]: ``,
  ["record"]: ``,
  ["rules"]: ``,
  ["account"]: ``,
  ["account_ph"]: ``,
  ["password"]: ``,
  ["password_ph"]: ``,
  ["remember_account"]: ``,
  ["invite_ratio"]: ``,
  ["invite_ratio_desc"]: ``,
  ["product_fee_ratio"]: ``,
  ["product_fee_ratio_desc"]: ``,
  ["register_count"]: ``,
  ["login_count"]: ``,
  ["deposit_count"]: ``,
  ["first_deposit_count"]: ``,
  ["deposit_amount"]: ``,
  ["withdraw_amount"]: ``,
  ["valid_bet_amount"]: ``,
  ["win_amount"]: ``,
  ["bonus_amount"]: ``,
  ["profit_amount"]: ``,
  ["link_manage"]: ``,
  ["add_link"]: ``,
  ["link_reached_limit"]: ``,
  ["copy_success"]: ``,
  ["submit"]: ``,
  ["cancel"]: ``,
  ["download"]: ``,
  ["sub_domain"]: ``,
  ["sub_domain_ph"]: ``,
  ["tag_name"]: ``,
  ["tag_name_ph"]: ``,
  ["link_status_0"]: ``,
  ["link_status_1"]: ``,
  ["link_status_2"]: ``,
  ["link_status_3"]: ``,
  ["link_sttaus_4"]: ``,
  ["month"]: ``,
  ["active_user_count"]: ``,
  ["product_fee_amount"]: ``,
  ["dividend_ratio"]: ``,
  ["dividend_amount"]: ``,
  ["status"]: ``,
  ["dividend_bill_status_0"]: ``,
  ["dividend_bill_status_4"]: ``,
  ["dividend_bill_status_9"]: ``,
  ["month_phase_1"]: ``,
  ["month_phase_2"]: ``,
  ["click_here"]: ``,
  ["click_here_desc"]: ``,
  ["available_commission"]: ``,
  ["time"]: ``,
  ["affiliate_program"]: ``,
  ["active_user_desc"]: ``,
  ["payout_instructions"]: ``,
  ["payout_instructions_detail"]: ``,
  ["rules_detail"]: ``,
  ["get_withdraw"]: ``,
  ["commission_history"]: ``,
  ["link_capacity"]: ``,
  ["language"]: ``,
  ["old_password"]: ``,
  ["old_password_ph"]: ``,
  ["new_password"]: ``,
  ["new_password_ph"]: ``,
  ["confirm_password"]: ``,
  ["confirm_password_ph"]: ``,
  ["confirm_password_not_same"]: ``,
  ["operation_success"]: ``,
  ["need_change_pwd_title"]: ``,
  ["need_change_pwd_content"]: ``,
  ["need_change_pwd_confirm"]: ``,
  ["err_5001"]: ``,
  ["err_5002"]: ``,
  ["err_5003"]: ``,
  ["err_6001"]: ``,
  ["err_6003"]: ``,
  ["err_6004"]: ``,
  ["err_2003"]: ``,
  ["err_2014"]: ``,
  ["date_picker_today"]: ``,
  ["date_picker_yesterday"]: ``,
  ["date_picker_7_days"]: ``,
  ["date_picker_30_days"]: ``,
  ["date_picker_this_month"]: ``,
  ["select_date_range"]: ``,
  ["date_picker_ok"]: ``,
  ["start_date"]: ``,
  ["end_date"]: ``,
  ["date_picker_year"]: ``,
  ["date_picker_month"]: ``,
  ["date_picker_day"]: ``,
}